import { render, staticRenderFns } from "./ApplicationReceivedItem.vue?vue&type=template&id=4583df7f&scoped=true"
import script from "./ApplicationReceivedItem.vue?vue&type=script&lang=js"
export * from "./ApplicationReceivedItem.vue?vue&type=script&lang=js"
import style0 from "./ApplicationReceivedItem.vue?vue&type=style&index=0&id=4583df7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4583df7f",
  null
  
)

export default component.exports